import { Controller } from '@hotwired/stimulus';
import noUiSlider from "nouislider";

export default class extends Controller {
  connect() {
    // Grab the slider container element
    const sliderElement = this.element.querySelector("#duration-slider");

    // Retrieve the primary color from the data attribute
    const primaryColor = this.data.get("primary-color");

    // Get the configuration values from the slider element's data attributes
    const min = parseInt(sliderElement.dataset.durationSliderMinValue);
    const max = parseInt(sliderElement.dataset.durationSliderMaxValue);
    const startMin = parseInt(sliderElement.dataset.durationSliderStartMin);
    const startMax = parseInt(sliderElement.dataset.durationSliderStartMax);

    // Create the slider
    noUiSlider.create(sliderElement, {
      start: [startMin, startMax],
      connect: true,
      range: {
        min: min,
        max: max,
      },
      tooltips: true,
      format: {
        to: (value) => Math.round(value),
        from: (value) => Number(value)
      }
    });

    // Update hidden fields during slider update
    sliderElement.noUiSlider.on("update", (values) => {
      document.getElementById("duration_min").value = values[0];
      document.getElementById("duration_max").value = values[1];
    });

    // When user stops sliding, trigger form submission
    sliderElement.noUiSlider.on("set", () => {
      const form = this.element.closest("form");
      form.submit();
    });

    // Optionally, apply the primary color to slider elements.
    // For example, set the background of the connect bar.
    const connectBar = sliderElement.querySelector('.noUi-connect');
    if (connectBar && primaryColor) {
      connectBar.style.backgroundColor = primaryColor;
    }
  }
}
